import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=38d1bee8&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

export default script